/*
 * Accept-donations.ts
 * Description: Includes the declaration
 * of the function for accepting donations
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex
import {store} from '@/config/plugins';

/**
 * Finishing a donation
 *
 * @return {Object} Promise - response with updated donations
 * @param {String} eventData - score of the donation
 * @param {String} user - score of the donation
 * @param {String} type - score of the donation
 */
export function getLog(eventData: string, user: string, type: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'audits',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
                events: eventData,
                user,
                type,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
